import {Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  standalone: true,
  imports: [
    RouterLink
  ],
  styleUrls: ['./intro.component.less']
})
export class IntroComponent {
  @ViewChild('intro') intro!: ElementRef;
  show: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @HostListener('document:scroll')
  onViewportScroll() {
    if (!isPlatformBrowser(this.platformId)) { return; }
    const windowHeight = window.innerHeight;
    const boundingRectFive = this.intro.nativeElement.getBoundingClientRect();

    if (boundingRectFive.top <= windowHeight - 200) {
      this.show = true;
    } else {
      this.show = false;
    }
  }
}
